import React, { useState } from 'react';
import '../styles/CategoryProposalModal.css';

interface CategoryProposalModalProps {
    onClose: () => void;
    onSubmit: (proposedCategory: string, additionalNote: string) => Promise<void>;
}

export const CategoryProposalModal: React.FC<CategoryProposalModalProps> = ({
    onClose,
    onSubmit
}) => {
    const [proposedCategory, setProposedCategory] = useState('');
    const [additionalNote, setAdditionalNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!proposedCategory.trim()) {
            setError('Prosím, vyplň názov kategórie');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            await onSubmit(proposedCategory.trim(), additionalNote.trim());
            onClose();
        } catch (err: any) {
            setError(err.message || 'Nepodarilo sa odoslať návrh');
            setLoading(false);
        }
    };

    return (
        <div className="category-proposal-overlay" onClick={onClose}>
            <div className="category-proposal-modal" onClick={(e) => e.stopPropagation()}>
                <button
                    onClick={onClose}
                    className="category-proposal-close"
                    aria-label="Zavrieť"
                >
                    ×
                </button>

                <h3 className="category-proposal-header">Návrh na pridanie kategórie</h3>

                <div className="category-proposal-info">
                    <p>
                        ℹ️ Tvoj návrh kategórie, názov položky a registračná emailová adresa budú zdieľané so SmartBloček tímom na vyhodnotenie.
                    </p>
                </div>

                {error && (
                    <div className="category-proposal-error">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="category-proposal-field">
                        <label htmlFor="proposed-category">
                            Aká kategória ti chýba? <span className="required">*</span>
                        </label>
                        <input
                            id="proposed-category"
                            type="text"
                            value={proposedCategory}
                            onChange={(e) => setProposedCategory(e.target.value)}
                            placeholder="Napr.: Elektronika > Mobilné telefóny"
                            disabled={loading}
                            maxLength={200}
                            autoFocus
                        />
                    </div>

                    <div className="category-proposal-field">
                        <label htmlFor="additional-note">
                            Dodatočné poznámky <span className="optional">(voliteľné)</span>
                        </label>
                        <textarea
                            id="additional-note"
                            value={additionalNote}
                            onChange={(e) => setAdditionalNote(e.target.value)}
                            placeholder="Môžeš pridať dodatočné informácie..."
                            disabled={loading}
                            maxLength={500}
                            rows={4}
                        />
                    </div>

                    <div className="category-proposal-actions">
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={loading}
                            className="btn-cancel"
                        >
                            Zrušiť
                        </button>
                        <button
                            type="submit"
                            disabled={loading || !proposedCategory.trim()}
                            className="btn-submit"
                        >
                            {loading ? 'Odosielam...' : 'Odoslať návrh'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
